<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import CkeditorWidget from "@/components/widgets/editor.vue";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  page: {
    title: "Form Soal Esai",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CkeditorWidget,
  },
  data() {
    return {
      title: "Soal Esai",
      items: [
        {
          text: "Master Soal",
          href: "/",
        },
        {
          text: "Form Soal Esai",
          active: true,
        },
      ],
      idKompetensi: this.$route.params.id,
      link: process.env.VUE_APP_BACKEND_URL,
      activeTab: "original", // "original" | "perbaikan"
      formData: {
        soal_text: "",
        soal_image: null,
        versi_soal: "",
        pertanyaan: "",
        jumlah_jawaban: "", // required jika Pilihan Ganda
        tipe: "Text", // Pilihan Ganda | Text
        keywords: [
          {
            keyword: "",
            skor: 0,
          },
        ], // required jika tipe Text
        kategori_idkategori: "",
        jawaban: [],
        timer: 0,
        nomor_urut: 1,
        previewUrl: "",
        approved: false,
        catatan: "",
      },
      kompetensi: {},
      listKategori: [],
      idSoal: this.$route.params.idsoal,
      showModalPreview: false,
      statusReview: "PENDING",
      perbaikanData: null,
      showModalPreviewPerbaikan: false,
      previewPerbaikanImageUrl: "",
    };
  },
  computed: {
    isVerifikasiLocked() {
      return this.statusReview === "COMPLETED";
    },
    perbaikanKeywords() {
      if (!this.perbaikanData || !this.perbaikanData.keywords) {
        return [];
      }
      const keywords =
        typeof this.perbaikanData.keywords === "string"
          ? JSON.parse(this.perbaikanData.keywords)
          : this.perbaikanData.keywords;
      return Array.isArray(keywords) ? keywords : [];
    },
    verifikasiStatusInfo() {
      const map = {
        PENDING: {
          alertClass: "alert-secondary",
          icon: "fa fa-clock",
          description: "Soal ini belum direview.",
        },
        REVIEWED: {
          alertClass: "alert-info",
          icon: "fa fa-eye",
          description: "Soal ini sudah direview dan tidak ditandai perlu revisi.",
        },
        REVISION: {
          alertClass: "alert-danger",
          icon: "fa fa-pen",
          description:
            "Soal ini ditandai perlu revisi dan sudah masuk ke antrian perbaikan di halaman Monitoring Review. Verifikasi ini masih bisa diedit selama belum di-approve.",
        },
        REPAIRED: {
          alertClass: "alert-primary",
          icon: "fa fa-wrench",
          description: "Soal ini sudah diperbaiki.",
        },
        COMPLETED: {
          alertClass: "alert-success",
          icon: "fa fa-check-circle",
          description:
            "Soal ini sudah di-approve dan dinyatakan tidak perlu revisi. Verifikasi ini tidak dapat diedit lagi.",
        },
      };
      return map[this.statusReview] || map.PENDING;
    },
  },
  async mounted() {
    Swal.fire({
      title: "Memuat data...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const tasks = [this.getKategori(), this.getKompetensi()];
    if (this.idSoal) {
      tasks.push(
        this.getData()
          .then(() => this.getVerifikasiStatus())
          .then(() => this.getPerbaikanSoal())
      );
    } else {
      tasks.push(this.getNextNomorUrut());
    }
    await Promise.all(tasks);

    Swal.close();
  },
  methods: {
    async getPerbaikanSoal() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/soal/" +
            this.idSoal +
            "/perbaikan",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });

      this.perbaikanData = data || null;
    },
    previewPerbaikanImage(url) {
      this.previewPerbaikanImageUrl = url;
      this.showModalPreviewPerbaikan = true;
    },
    async getVerifikasiStatus() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "review-soal/tools-asesmen/soal/" +
            this.idSoal +
            "/verifikasi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.formData.approved = data.approved === true;
        this.formData.catatan = data.catatan ?? "";
        this.statusReview = data.status_review ?? "PENDING";
      }
    },
    async getNextNomorUrut() {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi +
            "/soal/next-nomor-urut",
          {
            params: {
              tipe: this.formData.tipe,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data)
        .catch((err) => {
          console.log(err);
          return false;
        });
      if (data) {
        this.formData.nomor_urut = data.nomor_urut ?? data;
      }
    },
    async getData() {
      if (this.idSoal) {
        const data = await axios
          .get(
            process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/kompetensi/" +
              this.idKompetensi +
              "/soal/" +
              this.idSoal,
            {
              headers: {
                Authorization: "Bearer " + localStorage.access_token,
                Accept: "Application/json",
              },
            }
          )
          .then((response) => response.data.data)
          .catch((err) => {
            console.log(err);
            return false;
          });
        if (data) {
          this.formData = data;
        }
      }
    },
    async searchKategori(search, loading) {
      if (search.length) {
        loading(true);
        this.getKategori(search, loading);
      }
    },
    async getKategori(search = "", loading) {
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kategori/all",
          {
            params: {
              search: search,
              limit: 10,
            },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.listKategori = data;
      }
      if (loading) loading(false);
    },
    async getKompetensi() {
      // let idKompetensi = this.$router.params;
      console.log(this.$route.params.id);
      const data = await axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "master/kompetensi/" +
            this.idKompetensi,
          {
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
          }
        )
        .then((response) => response.data.data);

      if (data) {
        this.kompetensi = data;
      }
    },
    save() {
      if (!this.formData.approved && !this.formData.catatan?.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Catatan Wajib Diisi",
          text: "Catatan verifikasi wajib diisi kalau soal ini tidak di-approve.",
        });
        return;
      }

      // Endpoint verifikasi soal, dikelompokkan di prefix review-soal -> tools-asesmen (method POST)
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "review-soal/tools-asesmen/soal/" +
        this.idSoal +
        "/verifikasi";

      const detailText = this.formData.approved
        ? "Soal ini akan ditandai APPROVED sehingga status review-nya berubah menjadi COMPLETED (tidak perlu revisi)."
        : "Soal ini akan disimpan TANPA ditandai approved, sehingga status review-nya menjadi REVISION dan akan masuk ke antrian perbaikan di halaman Monitoring Review.";
      Swal.fire({
        icon: "warning",
        title: "Konfirmasi Verifikasi Soal",
        text: `Yakin akan menyimpan hasil verifikasi ini? ${detailText}`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya, Simpan`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            url: url,
            method: "post",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
              Accept: "Application/json",
            },
            data: {
              idkompetensi: this.idKompetensi,
              approved: this.formData.approved,
              catatan: this.formData.catatan,
            },
          })
            .then((response) => response.data.data)
            .catch((error) => {
              console.log(error);
              let err = error.response.data.data;
              Swal.fire({
                icon: "warning",
                title: "Terjadi Kesalahan",
                text: err,
                timer: 3000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              });
              return false;
            });
          if (data) {
            this.statusReview = data.status_review ?? this.statusReview;
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Verifikasi soal berhasil disimpan",
              timer: 1000,
              timerProgressBar: true,
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.backToList();
          }
        }
      });
    },
    inputFilePhoto() {
      let self = this;
      if ($("#formImage")[0].files[0]) {
        if ($("#formImage")[0].files[0].size < 2242880) {
          $("#uploadLoading").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#formImage")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoading").html("");
            $(".image").attr("src", urlres);
            $(".middle").attr("href", urlres);
            self.formData.soal_image = path_file;
            self.formData.previewUrl = urlres;
          });
        } else {
          alert("Max File 2 MB");
        }
      }
    },
    backToList() {
      return this.$router.push({
        name: "review-soal-text",
        params: { id: this.idKompetensi },
      });
    },
    isChecked(row) {
      return row.skor == 1;
    },
    previewImage() {
      // window.open(this.formData.previewUrl, "_blank");
      this.showModalPreview = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex justify-content-between">
                <div>
                  <div class="card-title">Form Soal Esai</div>
                  <div>
                    <span class="font-weight-bold">Kompetensi :</span>
                    <br />
                    <strong>{{ kompetensi?.nama_kompetensi || "-" }}</strong>
                  </div>
                  <div>
                    <span class="font-weight-bold">Level Proficiency :</span>
                    <br />
                    <strong>
                      {{ kompetensi?.level_kompetensi?.nama_level || "-" }}
                    </strong>
                  </div>
                </div>
                <div class="d-flex align-items-start gap-2"></div>
              </div>
              <div class="col-12">
                <hr />
                <ul class="nav mb-3 mym-inner-tabs">
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'original' }"
                      @click="activeTab = 'original'"
                    >
                      <i class="fa fa-file-alt me-1"></i>
                      Soal Original
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeTab === 'perbaikan' }"
                      @click="activeTab = 'perbaikan'"
                    >
                      <i class="fa fa-edit me-1"></i>
                      Perbaikan
                    </button>
                  </li>
                </ul>
              </div>

              <!-- TAB: SOAL ORIGINAL -->
              <div class="col-12" v-if="activeTab === 'original'">
                <div class="row mb-2">
                  <div
                    class="col-6 mb-2"
                    v-if="
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 3 ||
                      kompetensi?.level_kompetensi?.idlevel_kompetensi == 4
                    "
                  >
                    <div class="form group">
                      <label for="kategori_idkategori">Studi Kasus</label>
                      <v-select
                        id="form_kategori"
                        class="style-chooser"
                        :options="listKategori"
                        :reduce="(kategori) => kategori.idkategori"
                        label="kategori"
                        v-model="formData.kategori_idkategori"
                        placeholder="Pilih Kategori"
                        @search="searchKategori"
                        :disabled="true"
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="kategori_idkategori">Nomor Urut</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Nomor urut"
                        v-model="formData.nomor_urut"
                        readonly
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-1">
                    <div class="form group">
                      <label for="formImage" class="form-label">
                        Upload Gambar
                      </label>
                      <input
                        class="form-control"
                        type="file"
                        id="formImage"
                        v-on:change="inputFilePhoto()"
                        disabled
                      />
                      <div
                        class="respond-input-file float-left"
                        id="uploadLoading"
                      ></div>
                      <small class="float-right" style="color: red">
                        Max File 2 MB
                      </small>
                    </div>
                    <div class="container-image" v-if="formData.previewUrl">
                      <img :src="formData.previewUrl" class="image" />
                      <div
                        class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                      >
                        <button
                          class="btn btn-success btn-sm"
                          @click="previewImage"
                        >
                          <i class="fa fa-search"></i> Preview
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-2 form-group">
                    <label for="versi_soal">Versi Soal</label>
                    <input
                      type="text"
                      id="versi_soal"
                      class="form-control"
                      placeholder="Versi Soal"
                      v-model="formData.versi_soal"
                      disabled
                    />
                  </div>
                  <div class="col-12 mb-2 form-group">
                    <label for="pertanyaan">Pertanyaan</label>
                    <CkeditorWidget
                      v-model="formData.pertanyaan"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-12 mb-2">
                    <table class="table table-striped table-condensed">
                      <thead class="text-center bg-dark text-white">
                        <tr>
                          <th>Keyword</th>
                          <th width="100px">Poin</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(keyword, index) in formData.keywords"
                          :key="index"
                        >
                          <td>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              placeholder="Keywords"
                              v-model="keyword.keyword"
                              :disabled="true"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control form-control-sm"
                              placeholder="Poin"
                              v-model="keyword.skor"
                              :disabled="true"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- TAB: PERBAIKAN -->
              <div class="col-12" v-if="activeTab === 'perbaikan'">
                <div v-if="!perbaikanData" class="alert alert-secondary mb-0">
                  <i class="fa fa-info-circle me-1"></i>
                  Belum ada usulan perbaikan dari halaman Monitoring Review.
                </div>
                <div v-else>
                  <div class="row mb-3">
                    <div class="col-6 mb-2">
                      <div class="fw-semibold">Nomor Urut</div>
                      <div>{{ perbaikanData.nomor_urut || "-" }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <div class="fw-semibold mb-1">Gambar</div>
                      <div class="container-image" v-if="perbaikanData.soal_image">
                        <img
                          :src="link + perbaikanData.soal_image"
                          class="image"
                        />
                        <div
                          class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                        >
                          <button
                            class="btn btn-success btn-sm"
                            @click="previewPerbaikanImage(link + perbaikanData.soal_image)"
                          >
                            <i class="fa fa-search"></i> Preview
                          </button>
                        </div>
                      </div>
                      <div v-else>-</div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <div class="fw-semibold">Versi Soal</div>
                    <div>{{ perbaikanData.versi_soal || "-" }}</div>
                  </div>

                  <div class="mb-3">
                    <div class="fw-semibold mb-1">Pertanyaan</div>
                    <div v-html="perbaikanData.pertanyaan"></div>
                  </div>

                  <table class="table table-striped table-condensed mb-0">
                    <thead class="text-center bg-dark text-white">
                      <tr>
                        <th>Keyword</th>
                        <th width="100px">Poin</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(keyword, index) in perbaikanKeywords"
                        :key="index"
                      >
                        <td>{{ keyword.keyword || "-" }}</td>
                        <td class="text-center">{{ keyword.skor }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div
          class="card border"
          :class="formData.approved ? 'border-success' : 'border-warning'"
        >
          <div class="card-body bg-light">
            <h6
              class="card-title border-bottom pb-2 mb-3"
              :class="formData.approved ? 'text-success' : 'text-warning'"
            >
              <i class="mdi mdi-shield-check-outline me-1"></i>
              Verifikasi Soal
            </h6>

            <div
              class="alert d-flex align-items-center gap-2 mb-3"
              :class="verifikasiStatusInfo.alertClass"
            >
              <i :class="verifikasiStatusInfo.icon"></i>
              <div>
                <strong>{{ statusReview }}</strong> —
                {{ verifikasiStatusInfo.description }}
              </div>
            </div>

            <!-- APPROVED -->
            <div class="d-flex align-items-center gap-2 mb-3">
              <label class="form-label fw-semibold mb-0"> Approved </label>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="approved"
                  :checked="formData.approved === true"
                  :disabled="isVerifikasiLocked"
                  @change="formData.approved = $event.target.checked"
                />
              </div>
            </div>

            <!-- CATATAN -->
            <div class="mb-0">
              <label class="form-label fw-semibold mb-1">
                Catatan Verifikasi
                <span v-if="!formData.approved" class="text-danger">*</span>
                <small v-if="!formData.approved" class="text-muted fw-normal ms-1">
                  (wajib diisi kalau tidak di-approve)
                </small>
              </label>
              <textarea
                class="form-control"
                :class="formData.approved ? 'border-success' : 'border-warning'"
                rows="3"
                v-model="formData.catatan"
                :disabled="isVerifikasiLocked"
                placeholder="Tulis catatan atau feedback untuk soal ini..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-secondary" @click="backToList()">
            <i class="fa fa-arrow-left me-1"></i>
            Kembali
          </button>
          <button
            v-if="!isVerifikasiLocked"
            class="btn btn-primary"
            @click="save()"
          >
            <i class="fa fa-save me-1"></i>
            Verifikasi
          </button>
        </div>
      </div>
    </div>
  </Layout>

  <b-modal
    v-model="showModalPreview"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="formData.previewUrl" class="image" />
    </div>
  </b-modal>
  <b-modal
    v-model="showModalPreviewPerbaikan"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="previewPerbaikanImageUrl" class="image" />
    </div>
  </b-modal>
</template>
